// extracted by mini-css-extract-plugin
export default {"notesCard":"MyNotes_notesCard__USd5P","noDataNotification":"MyNotes_noDataNotification__X6O2U"};